import React, { Component } from 'react';
import { Link } from "react-router-dom";

import config from './../config';
import EntryView from './EntryView';
import FlokkurInfoView from './FlokkurInfoView';
import _ from 'underscore';

class SearchResultsList extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/api/nyyrdi/';

		this.state = {
			listData: [],
			fetching: true,
			initialized: false
		};
	}

	componentDidMount() {
		this.fetchData();
	}

	componentDidUpdate(prevProps, prevState) {
		// Skoðað hvort breytur hafa breyst og hvort component eigi að uppfærast
		if (
			prevProps.match.params.searchString != this.props.match.params.searchString || 
			prevProps.match.params.flokkur != this.props.match.params.flokkur ||
			prevProps.match.params.order != this.props.match.params.order ||
			prevProps.match.params.page != this.props.match.params.page
		) {
			this.fetchData();
		}
	}

	fetchData() {
		window.scrollTo(0, 0);

		// Sæki gögn til APA
		this.setState({
			listData: [],
			fetching: true,
			initialized: false
		});

		let urlParams = [];
		if (this.props.match.params.searchString) {
			urlParams.push('search='+this.props.match.params.searchString);
		}
		if (this.props.match.params.flokkur) {
			urlParams.push('flokkur='+this.props.match.params.flokkur);

			// Ef birta á innsend nýyrði þá röðum við þeim þannig að nýjustu koma fyrst
			if (this.props.match.params.flokkur == 'innsent') {
				urlParams.push('order=-inserttime');
			}
		}
		if (this.props.match.params.order) {
			urlParams.push('order='+(
//				this.props.match.params.order == 'vinsaelast' ? '-skyringar__einkunn' :
//				this.props.match.params.order == 'ovinsaelast' ? '-skyringar__downvotes' :
				this.props.match.params.order == 'stafrof' ? 'ord' :
				this.props.match.params.order == 'nyjast' ? '-inserttime' :
				this.props.match.params.order
			));
		}
		else {
			urlParams.push('order=-inserttime')
		}
		if (this.props.match.params.page) {
			urlParams.push('offset='+((this.props.match.params.page-1)*config.pageSize) : '');
		}

		fetch(this.url+'?'+urlParams.join('&'))
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					listData: _.uniq(json.results.reverse(), function(item) {
						return item.id;
					}).reverse(),
					prevUrl: json.previous || null,
					nextUrl: json.next || null,
					fetching: false
				})

				setTimeout(function() {
					this.setState({
						initialized: true
					});
				}.bind(this), 200);

			}.bind(this));

		if (this.props.onSearch) {
			this.props.onSearch(this.props.match.params);
		}
	}

	render() {
		let paginationUrl = '/leit/'+
			(this.props.match.params.searchString ? this.props.match.params.searchString : '')+
			(this.props.match.params.flokkur ? '/flokkur/'+this.props.match.params.flokkur : '')+
			(this.props.match.params.order ? '/rodun/'+this.props.match.params.order : '')
		;

		let paginationLinks = <React.Fragment>
			{
				this.state.prevUrl &&
				<div className="page-item">
					<Link className="page-link btn-primary" to={paginationUrl+(this.props.match.params.page ? '/sida/'+(parseInt(this.props.match.params.page)-1) : '')} aria-label="Previous">
						<span aria-hidden="true"><span className="arrows">&laquo;</span> Fyrri síða</span>
						<span className="sr-only">Fyrri síða</span>
					</Link>
				</div>
			}
			{
				this.state.nextUrl &&
				<div className="page-item">
					<Link className="page-link btn-primary" to={paginationUrl+(this.props.match.params.page ? '/sida/'+(parseInt(this.props.match.params.page)+1) : '/sida/2')} aria-label="Next">
						<span aria-hidden="true">Næsta síða <span className="arrows">&raquo;</span></span>
						<span className="sr-only">Næsta síða</span>
					</Link>
				</div>
			}
		</React.Fragment>;

		return (
			<React.Fragment>
				{
					this.props.match.params.flokkur &&
					<FlokkurInfoView flokkur={this.props.match.params.flokkur} />
				}
				<div className={'word-list'+(this.state.initialized ? ' initialized' : '')+(this.state.fetching ? ' fetching' : '')+(this.state.listData.length == 0 ? ' no-results' : '')}>
					{
						this.state.listData.length ?
						this.state.listData.map(function(item, index) {
							return <EntryView key={index} index={index} order={this.props.match.params.order} singleItem={false} data={item} />;
						}.bind(this)) : this.state.fetching ?
						<div />
						:
						<div>
							<h4>
								<span>{this.props.match.params.searchString ? 'Leitarorðið "'+this.props.match.params.searchString+'" skilaði engum niðurstöðum.' : 'Ekkert fannst'}</span>
							</h4>
						</div>
					}

					{
						(this.state.prevUrl || this.state.nextUrl) && this.state.listData.length > 0 &&
						<div className="index-pagination">
							<div className="pagination">
								{paginationLinks}
							</div>
						</div>
					}

				</div>
			</React.Fragment>
		);
	}
}

export default SearchResultsList;



// WEBPACK FOOTER //
// ./src/components/SearchResultsList.js